import { Routes, Route } from "react-router-dom"
import Admission from "./Pages/SchoolWebsite/Admission"
import Home from "./Pages/SchoolWebsite/Home"
import SignInForm from "./SignIn"
import About from "./Pages/SchoolWebsite/About"
import ResultChecker from "./Pages/SchoolWebsite/Result"
import Exam from "./Pages/SchoolWebsite/Exam"
import StudentPortal from "./Pages/SchoolWebsite/StudentPortal"
import SignInAd from "./Pages/sign-in/admin"
import SignInTea from "./Pages/sign-in/Teacher"
import SignInStu from "./Pages/sign-in/Student"
import Gallery from "./Pages/SchoolWebsite/Gallery"
import News from "./Pages/SchoolWebsite/News"
import Contact from "./Pages/SchoolWebsite/Contact"
import Curriculum from "./Pages/SchoolWebsite/Curriculum"
import Library from "./Pages/SchoolWebsite/Library"
import AddStudents from "./Pages/Admin/Teachers/AddStudents"
import Parents from "./Pages/Admin/Teachers/Parents"
import Teachers from "./Pages/Admin/Teachers/Teachers"
import ExamShedule from "./Pages/Admin/Teachers/ExamShedule"
import StudentAdmission from "./Pages/Admin/Teachers/StudentAdmission"
import StudentPromotion from "./Pages/Admin/Teachers/StudentPromotion"
import AddParents from "./Pages/Admin/Teachers/AddParents"
import Dashboardview from "./Pages/Admin/Teachers/Dashboardview"
import Main from "./Pages/Admin/Teachers/Main"
import Result from "./Pages/SchoolWebsite/Result"
import SuperAdmin from "./Pages/Admin/SuperAdmin"

export default function App() {
  return (
    <>
      <Routes>

        <Route path="/parents" element={<Parents />} />
        <Route path="/teachers" element={<Teachers />} />
        <Route path="/exam-shedule" element={<ExamShedule />} />
        <Route path="/teachers/admit" element={<StudentAdmission />} />
        <Route path="/teachers/promote-student" element={<StudentPromotion />} />
        <Route path="/teachers/add-parents" element={<AddParents />} />
        <Route path="/teachers/add-students" element={<AddStudents />} />
        <Route path="/" element={<Home />} />
        <Route path="/sign-in" element={<SignInForm />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/about" element={<About />} />
        <Route path="/results" element={<ResultChecker />} />
        <Route path="/exam" element={<Exam />} />
        <Route path="/portal" element={<StudentPortal />} />
        <Route path="/dashboard" element={<Dashboardview />} />
        <Route path="/main" element={<Main />} />
        <Route path="/signin-admin" element={<SignInAd />} />
        <Route path="/signin-teacher" element={<SignInTea />} />
        <Route path="/signin-student" element={<SignInStu />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/curriculum" element={<Curriculum />} />
        <Route path="/library" element={<Library />} />
        <Route path="/result" element={<Result />} />
        <Route path="/superadmin" element={<SuperAdmin />} />
      </Routes>

    </>
  )
}